import React from "react";

function NotFound() {
  return (
    <div className="flex flex-col gap-4 p-4 items-center justify-center h-screen">
      <div className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold">
        404
      </div>
      <div className="text-sm sm:text-base md:text-lg lg:text-xl mb-4 font-medium">
        Page Not Found
      </div>
      <a
        className="bg-black text-white px-4 py-2 rounded-md text-xs md:text-base"
        href="/"
      >
        Back to Self Assessment Guide
      </a>
    </div>
  );
}

export default NotFound;
